import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17 9.044V17H3V3h7.956l2-2H3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V7.044l-2 2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.53 2.029l2.439 2.44-7.739 7.738-3.23.792.792-3.231 7.738-7.74zm3.558 1.321L16.65.913l.406-.407a1.725 1.725 0 0 1 2.44 2.439l-.408.407z"
});

var SvgComposeMajorMonotone = function SvgComposeMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export { SvgComposeMajorMonotone as S };